import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { Moon, Sun, Palette, Check, Layout } from 'lucide-react';
import PageBackButton from '../components/PageBackButton';

const colorIcons = {
  light: Sun,
  dark: Moon,
  'ai-light': Palette,
  'ai-dark': Palette,
};

const ThemeSettingsPage = () => {
  const {
    style, setStyle, styles,
    colorScheme, setColorScheme, colorSchemes,
  } = useTheme();

  return (
    <div className="p-3 sm:p-4 md:p-6 lg:p-8 max-w-2xl">
      <div className="flex items-center gap-3 mb-4 sm:mb-6">
        <PageBackButton label="Back to Settings" to="/settings" preferHistory={false} hideLabelOnMobile />
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-textPrimary">
          Theme Settings
        </h1>
      </div>

      {/* Layout Style */}
      <div className="bg-backgroundSurface p-4 sm:p-6 rounded-lg shadow mb-6">
        <h2 className="text-lg font-semibold text-textPrimary mb-4">Layout Style</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {styles.map((s) => {
            const isActive = s.id === style;
            return (
              <button
                key={s.id}
                onClick={() => setStyle(s.id)}
                className={`flex items-center gap-3 p-4 rounded-lg border-2 transition
                  ${isActive
                    ? 'border-primary bg-primary/10 text-primary'
                    : 'border-borderDefault hover:border-primary/40 text-textPrimary hover:bg-primary/5'
                  }`}
              >
                <Layout className="w-5 h-5 shrink-0" />
                <span className="font-medium">{s.label}</span>
                {isActive && <Check className="w-5 h-5 ml-auto shrink-0" />}
              </button>
            );
          })}
        </div>
      </div>

      {/* Color Scheme */}
      <div className="bg-backgroundSurface p-4 sm:p-6 rounded-lg shadow">
        <h2 className="text-lg font-semibold text-textPrimary mb-4">Color Scheme</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {colorSchemes.map((c) => {
            const isActive = c.id === colorScheme;
            const Icon = colorIcons[c.id] || Palette;
            return (
              <button
                key={c.id}
                onClick={() => setColorScheme(c.id)}
                className={`flex items-center gap-3 p-4 rounded-lg border-2 transition
                  ${isActive
                    ? 'border-primary bg-primary/10 text-primary'
                    : 'border-borderDefault hover:border-primary/40 text-textPrimary hover:bg-primary/5'
                  }`}
              >
                <Icon className="w-5 h-5 shrink-0" />
                <span className="font-medium">{c.label}</span>
                {isActive && <Check className="w-5 h-5 ml-auto shrink-0" />}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ThemeSettingsPage;
